import { AxiosResponse } from "axios";
import { axiosInstance } from "./axiosInstance";
import { PaymentIntentDetailsDTO, PaymentIntentListDTO } from "../../models/EnrollmentHistoryDTO";

const base = (campusId: number) => `/admin/campus/${campusId}/paymentIntents`;

/** Bandeja de Caja: pagos por aplicar de matrículas nuevas. */
export class PaymentIntentsService {
	list = async (campusId: number, criteria: any, perPage: number, page: number): Promise<AxiosResponse<PaymentIntentListDTO>> =>
		axiosInstance.get<PaymentIntentListDTO>(`${base(campusId)}?perPage=${perPage}&page=${page}&criteria=${encodeURIComponent(JSON.stringify(criteria || {}))}`);
	details = async (campusId: number, intentId: number): Promise<AxiosResponse<PaymentIntentDetailsDTO>> =>
		axiosInstance.get<PaymentIntentDetailsDTO>(`${base(campusId)}/${intentId}/_details`);
	apply = async (campusId: number, intentId: number, payload: { tuitionIds: number[]; paidAmount?: number; paymentMethodId?: number; recipientAccountId?: number; paymentDate?: string; reference?: string; notes?: string }) =>
		axiosInstance.put<PaymentIntentDetailsDTO>(`${base(campusId)}/${intentId}/_apply`, payload);
	process = async (campusId: number, intentId: number, notes: string) => axiosInstance.put<PaymentIntentDetailsDTO>(`${base(campusId)}/${intentId}/_process`, { notes });
	/** Caja rechaza comprobantes en particular (índices) y puede adjuntar capturas (Esteban, 2026-09-23). */
	reject = async (campusId: number, intentId: number, notes: string, documentIndexes: number[], files?: File[]) => {
		const form = new FormData();
		form.append("notes", notes);
		form.append("documentIndexes", JSON.stringify(documentIndexes));
		(files || []).forEach((f) => form.append("files[]", f, f.name));
		return axiosInstance.post<PaymentIntentDetailsDTO>(`${base(campusId)}/${intentId}/_reject`, form, { headers: { "Content-Type": "multipart/form-data" } });
	};
	historyAttachment = async (campusId: number, intentId: number, eventIndex: number, index: number) =>
		axiosInstance.get<Blob>(`${base(campusId)}/${intentId}/_historyAttachment/${eventIndex}/${index}`, { responseType: "blob" });
	downloadDocument = async (campusId: number, intentId: number, index?: number) =>
		axiosInstance.get<Blob>(`${base(campusId)}/${intentId}/_document${index === undefined ? "" : "/" + index}`, { responseType: "blob" });
}
